export default "__VITE_PUBLIC_ASSET__36162d71__"